import fetch from 'utils/fetch';

export function queryCard(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/queryCard',
        method: 'post',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/queryCard.js